import t from '@jetshop/intl';
import * as React from 'react';
import styled from 'react-emotion';
import { theme } from '../Theme';

export const PaginationWrapper = styled('div')`
  margin-top: 1rem;
  .pagination {
    padding: 15px 5px;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #9a9a9a;
    > div {
      align-items: center;
    }
    button {
      padding: 10px 20px;
      text-transform: uppercase;
      letter-spacing: 1px;
      color: white;
      background: #212121;
      margin: 1px;
      &:disabled {
        opacity: 0.3;
      }

      ${theme.below.md} {
        padding: 10px;
        &.pagination-button {
          padding: 20px 10px;
        }
      }
    }
  }
`;

const Summary = styled('div')`
  margin-top: 1rem;
  h5 {
    text-align: center;
  }
  ${theme.below.md} {
    margin-top: 0;
  }
`;

const offset = 4;

const Pagination = ({
  prevPage,
  nextPage,
  currentPage,
  totalPages,
  isFirstPage,
  isLastPage,
  hasPages,
  goToPage,
}) => {
  const begin = currentPage <= 4 ? 0 : currentPage - offset;
  const end = currentPage <= 4 ? 7 : currentPage + (offset - 1);

  let pages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  pages = totalPages === 1 ? pages : pages.slice(begin, end);

  return hasPages ? (
    <PaginationWrapper>
      <div className="pagination">
        <button
          onClick={prevPage}
          disabled={isFirstPage}
          className="pagination-button"
        >
          {'<'}
        </button>
        <div>
          {pages.map((page, index) => {
            return (
              <button
                key={index}
                onClick={() => goToPage(page)}
                disabled={page === currentPage}
              >
                {page}
              </button>
            );
          })}
        </div>

        <button
          onClick={nextPage}
          disabled={isLastPage}
          className="pagination-button"
        >
          {'>'}
        </button>
      </div>
      <Summary>
        <h5>
          {t('Page')} {currentPage} {t('of')} {totalPages}{' '}
        </h5>
      </Summary>
    </PaginationWrapper>
  ) : null;
};
export default Pagination;
